import { Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import styled from "styled-components";

const StyledInputRow = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  width: 100%;
`;

const StyledInput = styled(Input)`
  flex: 1;
`;

const StyledAddValueButton = styled.button`
  padding: 4px 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;

  &:hover {
    border-color: #1890ff;
    color: #1890ff;

    .anticon {
      color: inherit;
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    border-color: #d9d9d9;
    color: #d9d9d9;
  }
`;

const StyledPlusIcon = styled(PlusOutlined)`
  font-size: 12px;
`;

/**
 * Display component for text values
 * Handles: arrays, single value
 */
function UdfTextDisplay({ value }) {
  // Handle array of values
  if (Array.isArray(value)) {
    return (
      <>
        {value.map((val, index) => (
          <span key={index}>
            {String(val)}
            {index < value.length - 1 && ", "}
          </span>
        ))}
      </>
    );
  }

  return String(value);
}

/**
 * Text input component for UDF filters
 */
function UdfTextEdit({ addValue, currentValue, setCurrentValue, canAddCurrentValue }) {
  return (
    <StyledInputRow>
      <StyledInput
        placeholder="Enter text value"
        value={currentValue || ""}
        onChange={(e) => setCurrentValue(e.target.value)}
      />
      <StyledAddValueButton
        onClick={() => addValue(currentValue)}
        disabled={!canAddCurrentValue}
        aria-label="Add text value"
      >
        <StyledPlusIcon />
      </StyledAddValueButton>
    </StyledInputRow>
  );
}

/**
 * Factory function that returns both Edit and Display components
 */
function UdfText() {
  return {
    Edit: UdfTextEdit,
    Display: UdfTextDisplay,
  };
}

export default UdfText;
